import { getSupplierList, getSupplierGj, getSupplierLabelApi, getDynamicPriceSupplierListApi } from '@/api/bas/supplier'

const supplier = {
  state: {
    supplier: [],
    supplierGj: [],
    supplierLabel:[],
    dynamicPriceSupplierList: [], // 可供货SKU清单中有时价货的供应商
  },
  actions: {
    getSupplier({commit, state},parms={}) {
      if (state.supplier == null || state.supplier.length === 0) {
        getSupplierList(parms).then(res => {
          commit('setSupplier', res.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetSupplier({commit, state},parms={}) {
      getSupplierList(parms).then(res => {
        commit('setSupplier', res.data)
      }).catch(err => {
        console.log(err)
      })
    },
    getSupplierGj({commit, state},areaCode) {
      if (state.supplierGj == null || state.supplierGj.length === 0) {
        getSupplierGj({areaCode:areaCode}).then(res => {
          commit('setSupplierGj', res.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetSupplierGj({commit, state},areaCode) {
      getSupplierGj({areaCode:areaCode}).then(res => {
        commit('setSupplierGj', res.data)
      }).catch(err => {
        console.log(err)
      })
    },
    getSupplierLabel({commit, state}) {
      if (state.supplierLabel.length === 0) {
        getSupplierLabelApi({tableName: "supplierTag" }).then(res => {
          commit('setSupplierLabel', res.data);
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetSupplierLabel({commit, state}) {
      getSupplierLabelApi({tableName: "supplierTag"}).then(res => {
        commit('setSupplierLabel', res.data);
      }).catch(err => {
        console.log(err)
      })
    },
    getDynamicPriceSupplierList({commit, state}) {
      if (state.dynamicPriceSupplierList.length === 0) {
        getDynamicPriceSupplierListApi({search: ''}).then(res => {
          commit('setDynamicPriceSupplierList', res.data);
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetDynamicPriceSupplierList({commit, state}) {
      getDynamicPriceSupplierListApi({search: ''}).then(res => {
        commit('setDynamicPriceSupplierList', res.data);
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mutations: {
    setSupplier: (state, data) => {
      state.supplier = data
    },
    setSupplierGj: (state, data) => {
      state.supplierGj = data
    },
    setSupplierLabel: (state, data) => {
      state.supplierLabel = data
    },
    setDynamicPriceSupplierList: (state, data) => {
      state.dynamicPriceSupplierList = data
    }
  }
}

export default supplier
